import React from 'react';
import FormOne from '../contact/FormOne';
import { Link } from "react-scroll";
import { useTranslation } from 'react-i18next';

const BannerFive = () => {
    const { t } = useTranslation();

    return (
        <div className="banner banner-style-5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/images/banner/chateau.webp"})` }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-xl-7">
                        <div className="banner-content">
                            <p className="h1 title">{t('Electricité')} &amp; {t('Technologie')}</p>
                            <div>
                                <Link
                                    href='#nossosprojetos'
                                    to="nossosprojetos"  // Replace with the ID of your target section
                                    smooth={true}
                                    duration={500}      // Adjust the duration as needed (in milliseconds)
                                    offset={-50}        // Adjust the offset if needed (to account for fixed headers, for example)
                                >
                                    <button className="axil-btn btn-fill-primary btn-fluid btn-primary dark_text_color">{t('Voir plus')}</button>
                                </Link>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-5">
                        <div className="banner-form">
                            <div className="contact-form-box shadow-box">
                                <p className="title h3">{t('Demander un devis gratuitement')}</p>
                                <FormOne />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerFive;